module.exports = __webpack_public_path__ + "img/sparky-works.9e8d0dbf.png";